import './slide2.scss';

export const Slide2 = () => {
    return (
        <div className='container-slide slide2'>

            <div className='div-pai-slides' >

                <h1 className='bracket-title'> Para sua empresa </h1>
                <p className='slide-subtitle'>
                    Tranquilidade para focar no que realmente importa: o seu negócio
                </p>
                <p className='slide-text'>
                    Nossos produtos de crédito otimizam suas operações, reduzindo riscos
                    e ampliando as possibilidades de atuação no mercado internacional,
                    aumentando a rentabilidade, fidelizando clientes, diversificando a carteira
                    de produtos e expandindo sua atuação para além do mercado doméstico.
                </p>

                <a className='slide-button' style={{marginTop:"10px"}} href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>

            </div>

        </div>

    )
}
